import { ApiResponse, AdvancedSearchTypes } from 'app/types-shared';
import { RemoteData } from '../../infrastructure/remote-data';
import { endpoint } from './constants';
import { AdvancedSearchField, FilterDomainsResults } from 'app/components/filters/types';
import { PreDefDateResult } from './types';
import { reportTypes } from 'app/area/favourite/constants';

export const api = {
  loadFilters: async (reportType?: number, reportId?: number): Promise<FilterDomainsResults> => {
    const response = await new RemoteData(reportType && reportId
      ? (reportType === reportTypes.specialReport ? endpoint.filterDomainsSpecialReport(reportId) :
        reportType === reportTypes.dashboard ? endpoint.filterDomainsDashboard(reportId) : endpoint.filterDomains)
      : reportType === reportTypes.bowtieConnectedCasesInfo ? endpoint.filterDomainsBowtie : endpoint.filterDomains)
      .resource<ApiResponse<any>>()
      .all();

    return response.data;
  },

  loadDefaultPredefDate: async (dbFunction: number): Promise<string> => {
    const response = await new RemoteData(endpoint.defaultPredefDate(dbFunction))
      .resource<ApiResponse<PreDefDateResult>>()
      .single();
    return response.data.date;
  },

  loadAdvancedSearchTypes: async (): Promise<AdvancedSearchTypes[]> => {
    const response = await new RemoteData(endpoint.favouriteAdvancedSearchTypes)
      .resource<ApiResponse<AdvancedSearchTypes[]>>()
      .single();
    return response.data;
  },

  loadAdvancedSearchFields: async ({
    optionsIds,
    applicationExcluded
  }:
    { optionsIds: number[]; applicationExcluded?: boolean }): Promise<AdvancedSearchField[]> => {
    const response = await new RemoteData(endpoint.favouriteAdvancedSearchFields)
      .resource<ApiResponse<any>>()
      .filter({ applicationId: optionsIds, ...(applicationExcluded && { applicationExcluded }) })
      .single();

    return response.data;
  },

  loadAdvancedSearchFieldsSearch: async ({
    optionsIds,
    query,
    applicationExcluded
  }:
    { optionsIds: number[]; query: string; applicationExcluded?: boolean }): Promise<AdvancedSearchField[]> => {
    const response = await new RemoteData(endpoint.searchFavouriteAdvancedSearchFields)
      .resource<ApiResponse<any>>()
      .filter({ applicationId: optionsIds, query, ...(applicationExcluded && { applicationExcluded }) })
      .single();

    return response.data;
  }

};
